import React from 'react'
import { useTranslation } from 'react-i18next'
import type { DateFormat } from '~common/utils/date-transformation/types'
import { ExpandableSection } from '../section-wrapper'
import { FormGroup, Select } from '../shared-styles'
import type { SettingsModalLogic } from '../../logic'

interface DateFormatSectionProps {
    logic: SettingsModalLogic
    state: { dateFormat: DateFormat }
    expanded: boolean
    onToggle: () => void
    showTitleInSection?: boolean
}

export const DateFormatSection: React.FC<DateFormatSectionProps> = ({
    logic,
    state,
    expanded,
    onToggle,
    showTitleInSection = true,
}) => {
    const { t } = useTranslation('settings')
    return (
        <ExpandableSection
            iconName="calendar"
            title={t('sections.dateFormat.title')}
            description={t('sections.dateFormat.description')}
            expanded={expanded}
            onToggle={onToggle}
            showTitleInSection={showTitleInSection}
        >
            <FormGroup>
                <Select
                    id="dateFormat"
                    value={state.dateFormat}
                    onChange={(e) =>
                        logic.updateDateFormat(e.target.value as DateFormat)
                    }
                >
                    {logic.getDateFormatOptions().map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label} - {option.example}
                        </option>
                    ))}
                </Select>
            </FormGroup>
        </ExpandableSection>
    )
}
